import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Input,
  FormGroup,
  Label
} from 'reactstrap'
import ModalViewLead from '../../modals/ModalListLeads'
import api from '../../services/api';

export default function Lead() {
  let id_company = localStorage.getItem('followize_id_company');
  let id_contact = localStorage.getItem('followize_id_contact');
  let id_user = localStorage.getItem('followize_id_user');
  let email = localStorage.getItem('email_user');

  const [title, setTitle] = useState('')
  const [teams, setTeams] = useState([])
  const [selectTeam, setSelectTeam] = useState('')
  const [visible, setVisible] = useState(false)
  const history = useHistory()

  const storeLead = async (e) => {
    e.preventDefault();

    if (!title) {
      alert('Um título deve ser informado')
      return
    }

    if (!selectTeam) {
        alert('Um time deve ser selecionado')
        return
      }

    try {
      await api.post('lead/save', {id_company, id_contact, id_user, 'descricao': title, 'team': selectTeam, email});
      
      alert('Lead salvo com sucesso')
      
      history.push(`/?id_company=${id_company}&id_contact=${id_contact}&id_user=${id_user}`);

    } catch (err) {
      console.log(err);
    }
  }

  const getTeams = async () => {
    const response = await api.get(`lead/teams?id_company=${id_company}`);

    setTeams(response.data.teams)
  }

  const openModal = () => {
    setVisible(true);
  }

  useEffect(() => {

    getTeams()

  }, [])

  return (
    <>
      <FormGroup>
        <Label style={{ color: 'rgba(0,0,0,0.6)' }}>Título</Label>
        <Input
          className="form-input"
          style={{ height: '35px', marginTop: '-5px', fontSize: '15px' }}
          id='titleLead'
          placeholder="Título do Lead"
          value={title}
          onChange={(item) => setTitle(item.target.value)}
        />
      </FormGroup>

      <FormGroup style={{ marginTop: '0' }}>
        <Label style={{ color: 'rgba(0,0,0,0.6)' }}>Time</Label>
        <Input type="select" name="select" onChange={event => setSelectTeam(event.target.value)} style={{ height: '35px', marginTop: '-5px', fontSize: '15px' }} defaultValue="0">
          <option disabled value='0'>Time</option>
          {teams.map((team, index) =>
            <option key={index} value={team.Item}>{team.Nome}</option>
          )}
        </Input>
      </FormGroup>

      <br />

      <button
        onClick={storeLead}
        className="button"
        style={{ marginTop: '-10px', width: '49%', marginRigth: '1%', fontSize: '14px', height: '45px' }}
      >
        Cadastrar Lead
          </button>

      <button
        onClick={openModal}
        className="button"
        style={{ marginTop: '-10px', width: '49%', marginLeft: '1%', fontSize: '14px', height: '45px' }}
      >
        Visualizar Leads
          </button>

      <ModalViewLead visible={visible} modalVisible={setVisible} />
    </>
  )
}